
import Home from '../pages/Home/Home';
import Main from '../pages/main';
import Login from '../pages/Login/Login';
import ForgetPwd from '../pages/Login/ForgetPwd';
import ChangeMobilePwd from '../pages/Login/ChangeMobilePwd';
import ViewBalance from '../pages/BalanceTrans/ViewBalance';
import ViewTrans from '../pages/BalanceTrans/ViewTrans';
import CounterMgt from '../pages/CounterMgt/CounterMgt';
import Settings from '../pages/Settings/Settings';
import Servicing from '../pages/Servicing/Servicing';
import Faqs from '../pages/Servicing/Faqs';
import UserManagement from '../pages/UserManagement/UserManagement';
import NoFoundPage from '../pages/NoFoundPage'
import StoreList from '../pages/StoreList/StoreList';
import RoleManagement from '../pages/Settings/RoleManagement'
import MenuManagement from '../pages/Settings/MenuManagement';
import DictionaryManagement from '../pages/Settings/DictionaryManagement';
import MerchantManagement from '../pages/MerchantManagement/MerchantManagement';
import ErrorPage from '../pages/ErrorPage/ErrorPage';
import SuccessPage from '../pages/Settings/ChangeSuccess';
import AddMerchant from '../pages/Login/AddMerchant';

export const routerConfigList = [
    { page: 'StoreList', path: '/storeList', exact: true, component: StoreList },
    { page: 'Main', path: '/page', exact: true, component: Main },
    { page: 'Login', path: '/login', exact: true, component: Login },
    { page: 'changeMobilePwd', path: '/changeMobilePwd', exact: true, component: ChangeMobilePwd },
    { page: 'ForgetPwd', path: '/forgetPwd', exact: true, component: ForgetPwd },
    { page: 'ErrorPage', path: '/error', exact: true, component: ErrorPage },
    { page: 'SuccessPage', path: '/success', exact: true, component: SuccessPage },
    { page: 'AddMerchant', path: '/addMerchant', exact: true, component: AddMerchant },
];

export const routerlist = [
    { page: 'Home', path: '/page/home', exact: true, component: Home },
    { page: 'User Management', path: '/page/userManagement/user', exact: true, component: UserManagement },
    { name: 'View Balance', path: "/page/balanceTrans/viewBalance", exact: true, component: ViewBalance },
    { name: 'View Transaction History', path: "/page/balanceTrans/viewTrans", exact: true, component: ViewTrans },
    { page: 'Counter Management', path: '/page/counter', exact: true, component: CounterMgt },
    { page: 'Change My Password', path: '/page/settings/changePassword', exact: true, component: Settings },
    { page: 'Role Management', path: '/page/settings/roleManagement', exact: true, component: RoleManagement },
    { page: 'Menu Management', path: '/page/settings/menuManagement', exact: true, component: MenuManagement },
    { page: 'Dictionary Management', path: '/page/settings/dictionaryManagement', exact: true, component: DictionaryManagement },
    { page: 'Service Request', path: '/page/servicing/service', exact: true, component: Servicing },
    { page: 'FAQS', path: '/page/servicing/faqs', exact: true, component: Faqs },
    { page: '404', path: '/page/404', exact: true, component: NoFoundPage },
    { page: 'Merchant Management', path: '/page/merchantManagement/merchant', exact: true, component: MerchantManagement },
]
